var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.url}},[_c('div',{staticClass:"card card-lg card-grande"},[_c('div',{staticClass:"row header"},[_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"row body"},[_c('div',{staticClass:"col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.description))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19babd93","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CardLG.vue
// module id = zXfg
// module chunks = 15